import React from 'react'
import './login.scss'
import { Container, NavLink, Form, Button, FloatingLabel } from 'react-bootstrap'
import { images } from '../../utils/customFn'
import {ContactIcon} from '../../icon/icons'
const Login = () => {
    return (
        <>
            <div className='login-main'>
                <Container>
                    <div className='login-wrapper'>
                        {/* top header starts */}
                        <div className='top-heading'>
                            <img src={images['logo.svg']} alt="logo" />
                            <NavLink to={'#/'}>Contact us</NavLink>
                        </div>
                        {/* top header ends */}

                        {/* login container starts */}
                        <div className='login-main-container'>
                            <div className='main-login-heading'>
                                <h1>Access your account</h1>
                            </div>
                            <Form className='form'>
                                <FloatingLabel
                                    controlId="floatingInput"
                                    label="Username"
                                    className=""
                                >
                                    <Form.Control type="text" placeholder="" />
                                </FloatingLabel>
                                <FloatingLabel controlId="floatingPassword" label="Password">
                                    <Form.Control type="password" placeholder="Password" />
                                </FloatingLabel>
                                <Form.Group className="" controlId="formBasicCheckbox">
                                    <Form.Check type="checkbox" label="Remember my username" />
                                </Form.Group>
                                <Button variant="primary" className='login-btn' type="submit">
                                    Log In
                                </Button>
                            </Form>
                            <div className='bottom-links'>
                                <NavLink to={'#/'}>Forgot password?</NavLink>
                                <NavLink to={'#/'}>Register for online access</NavLink>
                            </div>
                        </div>
                        {/* login container ends */}

                        {/* quick pay starts */}
                        <div className='quick-pay-section'>
                          <h3>Quick pay</h3>
                          <p>Know your account number and ZIP code? If so, you can use Quick pay to pay your bill without signing in.</p>
                          <NavLink to={'#/'}>Pay your bill</NavLink>
                        </div>
                        {/* quick pay ends */}

                        <div className='question-bottom'>
                            <h3>Have a question? Give us a call.</h3>
                            <h4><ContactIcon /> 800-473-6879</h4>
                        </div>
                        <div className="bottom-links-wrapper">
                            <NavLink to="https://www.sentry.com/company-identification">Legal disclaimer</NavLink>
                            <span>|</span>
                            <NavLink to="https://www.sentry.com/terms-conditions">Terms and conditions</NavLink>
                            <span>|</span>
                            <NavLink to="https://www.sentry.com/privacy">Privacy policy</NavLink>
                            <span>|</span>
                            <span>©2020</span>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}

export default Login